import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PharmGroupModel } from '../models/PharmGroupModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class PharmGroupService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }


  public getPharmGroupLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<PharmGroupModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PharmGroup/PharmGroupLookupTop', options);
  }
}
